import { Backpack, Gem, Gift, ShieldCheck } from "lucide-react";

interface ShortcutItem {
  href: string;
  title: string;
  text: string;
  icon: typeof Backpack;
  always?: boolean;
  needsVoucher?: boolean;
  needsGems?: boolean;
}

const shortcuts: ShortcutItem[] = [
  { href: "/rescue", title: "回穩補給金", text: "完成新人七關後可申請，官方人工審核。", icon: ShieldCheck, always: true },
  { href: "/inventory", title: "查看背包", text: "查看寶石碎片、紅包券與閃耀值", icon: Backpack, always: true },
  { href: "/red-packet", title: "紅包池", text: "持有紅包券即可抽獎，依不同獎池開啟不同獎勵", icon: Gift, needsVoucher: true },
  { href: "/gems", title: "寶石兌換", text: "寶石碎片可兌換紅包券與未來輪盤資格", icon: Gem, needsGems: true }
];

export function LobbyShortcutGrid({ vouchers = 0, gems = 0 }: { vouchers?: number; gems?: number }) {
  const visibleShortcuts = shortcuts.filter((item) => {
    if (item.needsVoucher) return vouchers > 0;
    if (item.needsGems) return gems >= 3;
    return true;
  });

  return (
    <section className="shortcut-grid core-activity-grid" aria-label="非重複活動入口">
      {visibleShortcuts.map((item) => {
        const Icon = item.icon;
        return (
          <a className={`lobby-shortcut ${item.always ? "backpack-entry-card" : ""}`} href={item.href} key={item.href}>
            <span><Icon size={22} /></span>
            <div>
              <strong>{item.title}</strong>
              <small>{item.text}</small>
            </div>
          </a>
        );
      })}
    </section>
  );
}
